import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    borderRadius: 6,
    padding: theme.spacing(0.25, 1.25),
    boxSizing: 'border-box',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5, 1.5),
    },
  },
  green: {
    backgroundColor: theme.palette.greenPantone,
  },
  pink: {
    backgroundColor: theme.palette.grapePurple,
  },
  highlight: {
    color: theme.palette.common.white,
    fontFamily: 'Raleway',
    fontWeight: 800,
    fontSize: 34,
    lineHeight: 1,
  },
  text: {
    color: theme.palette.common.white,
    fontFamily: 'Raleway',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: 1.25,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  textBesideHighlight: {
    textAlign: 'left',
  },
}))

export default styles
